export default __webpack_public_path__ + "static/media/boschsans_boldItalic.f0a85ac1.woff2";